import React, {useEffect} from 'react'
import { Dialog } from 'primereact/dialog';
import { baseURL } from "../../../service/HttpService";
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'redux/hooks';
import {getTapPerformanceReport} from 'redux/pages/Reports/ProvenOutcomesSlice';

interface DocumentViewerPropType {
    showModal: boolean;
    setShowModal: (state: boolean) => void;
    fileName?: string;
    setFileName: (state: any) => void;
    uniqueProjectId?: any;
}
const TAPPerformanceReportViewer: React.FC<DocumentViewerPropType> = ({
    showModal = false,
    setShowModal = () => { },
    fileName = "",
    setFileName = () => { },
    uniqueProjectId = "",
}) => {

    const reportUrl = useAppSelector((state) => state.provenOutcomes.reportUrl);
    const dispatch = useDispatch<any>();
   
    useEffect(() => {
        if (showModal && uniqueProjectId) {
            dispatch(getTapPerformanceReport(uniqueProjectId));
        }
    }, [uniqueProjectId]);

    
    return (
        <div>
            <Dialog
                header={<span title={`${fileName}`}>View Report ({fileName})</span>}
                visible={showModal}
                style={{ width: "75vw", height: "85%" }}
                onHide={() => {
                    setShowModal(false);
                    setFileName('');
                }}
                className="view-file-modal">
                <div className="content-box">
                    <div className='file-content'>
                        {(reportUrl) ?
                            <object data={reportUrl} title={fileName} type="application/pdf" width="100%" height="100%" ></object>
                            :
                            (<></>)
                        }
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default TAPPerformanceReportViewer;